import { provideHttpClient, withInterceptors } from '@angular/common/http';
import type { ApplicationConfig } from '@angular/core';
import { provideBrowserGlobalErrorListeners } from '@angular/core';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';
import { provideRouter } from '@angular/router';

import { authInterceptor } from '../core/interceptors/auth-interceptor';

import { APP_DATE_FORMATS, AppDateAdapter } from './app-date-config';
import { appMatIconConfig } from './app-mat-icon.config';
import { routes } from './app-routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    {
      provide: DateAdapter,
      useClass: AppDateAdapter,
    },
    { provide: MAT_DATE_FORMATS, useValue: APP_DATE_FORMATS },
    { provide: MAT_ICON_DEFAULT_OPTIONS, useValue: appMatIconConfig },
    provideHttpClient(withInterceptors([authInterceptor])),
  ],
};
